'use client';

import { useTranslations } from 'next-intl';

import { useGetUrlWithAnonymousId } from '@flipster/features/src/shared/hooks/useGetUrlWithAnonymousId';
import { FormattedMessage } from '@flipster/i18n';
import { Button } from '@flipster/react/design-system/button';
import { useMounted } from '@flipster/react/misc/lifecycle/mount';
import { useBreakpoint } from '@flipster/react/misc/responsive';
import { css } from '@flipster/styled-system/css';
import { hstack, stack } from '@flipster/styled-system/patterns';

import AppLogo from '@web/assets/images/logo/app-icon.svg';

const DownloadApp = () => {
  const t = useTranslations();
  const isMounted = useMounted();
  const { isMobile } = useBreakpoint();
  const getUrlWithAnonymousId = useGetUrlWithAnonymousId();

  if (!isMounted || !isMobile) return null;
  return (
    <section
      className={hstack({
        pos: 'fixed',
        left: 0,
        bottom: 0,
        w: '100%',
        px: 16,
        py: 12,
        bgColor: 'inverse.white',
      })}
    >
      <AppLogo width={36} height={36} />
      <div className={stack({ ml: 12, flex: 1 })}>
        <h2 className={css({ textStyle: 'Text/L/Strong', color: 'inverse.black' })}>
          <FormattedMessage id='Autogen_common.r251126.s_Flipster_app' />
        </h2>
        <p className={css({ textStyle: 'Text/S/Regular', color: 'content.default.level-1' })}>
          <FormattedMessage id='Autogen_common.r251126.s_Trade_on_the_go' />
        </p>
      </div>
      <Button
        hierarchy='primary'
        color='accent'
        size='small'
        as='a'
        href={getUrlWithAnonymousId('DownloadAppForTrade')}
        newTab
        label={t('Autogen_common.r251126.s_Start')}
      />
    </section>
  );
};

export default DownloadApp;
